import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import moment from "moment";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
// import { useDispatch, useSelector } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { setMDLanguage } from "../../actions/language";
import { ReactComponent as IconAU } from "../../assets/images/icon-au.svg";
import { ReactComponent as IconES } from "../../assets/images/icon-es.svg";
import { ReactComponent as IconGB } from "../../assets/images/icon-gb.svg";
import { ReactComponent as IconIE } from "../../assets/images/icon-ie.svg";
import { ReactComponent as IconNZ } from "../../assets/images/icon-nz.svg";
import { ReactComponent as IconUS } from "../../assets/images/icon-us.svg";
import { ReactComponent as IconCA } from "../../assets/images/icon-ca.svg";
// import useUserback from "../../hooks/useUserback";
import { IReduxAppState } from "../../reducers";

import "moment/locale/es";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    select: {
      display: "flex",
      flexDirection: "row",
      marginRight: "1rem",
      "@media (max-width: 600px)": {
        margin: "0",
      },
      "&>div": {
        display: "flex",
        flexDirection: "row",
        width: "6rem",
        "@media (max-width: 600px)": {
          width: "1rem",
        },
      },
      "& .MuiListItemIcon-root": {
        minWidth: "32px",
        display: "flex",
        alignItems: "center",
      },
      "& .MuiListItemText-root": {
        "@media (max-width: 600px)": {
          display: "none",
        },
      },
    },
    item: {
      "& .MuiListItemIcon-root": {
        minWidth: "32px",
        display: "flex",
        alignItems: "center",
      },
    },
  })
);

interface Language {
  value: string;
  text: string;
  icon: any;
}

interface Languages {
  [value: string]: Language;
}

const languages: Languages = {
  au: {
    value: "en-au",
    text: "EN-AU",
    icon: IconAU,
  },
  ca: {
    value: "ca",
    text: "EN-CA",
    icon: IconCA,
  },
  gb: {
    value: "en-gb",
    text: "EN-GB",
    icon: IconGB,
  }, 
  ie: {
    value: "en-ie",
    text: "EN-IE",
    icon: IconIE,
  },
  nz: {
    value: "en-nz",
    text: "EN-NZ",
    icon: IconNZ,
  },
  us: {
    value: "us",
    text: "EN-US",
    icon: IconUS,
  },
  es: {
    value: "es-es",
    text: "ES-ES",
    icon: IconES,
  },
};

const LanguagePicker = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { i18n } = useTranslation();
  // const history = useHistory();
  // const { getUserbackForm } = useUserback();

  const currentLanguage = useSelector(
    (state: IReduxAppState) => state.language.current
  );

  useEffect(() => {
    i18n.changeLanguage(currentLanguage);

    moment.locale(currentLanguage.split("-")[0]);

    // getUserbackForm(currentLanguage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLanguage]);

  useEffect(() => {
    const browserLanguage = navigator.language.toLowerCase();
    const storedLanguage = localStorage.getItem("language");

    const conditionedBrowserLanguage =
      Object.values(languages).find((language: Language) => {
        return language.value.includes(browserLanguage);
      })?.value || languages.gb.value;

    if (!storedLanguage) {
      dispatch(setMDLanguage(conditionedBrowserLanguage));
    }

    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);




  const render = () => {
    return Object.values(languages).map((language: Language) => {
      return (
        <MenuItem
          className={classes.item}
          value={language.value}
          key={language.text}
        >
          <ListItemIcon>
            <language.icon />
          </ListItemIcon>

          <ListItemText
            data-component-name={`LANGUAGE_${language.text}`}
            primary={language.text}
          />
        </MenuItem>
      );
    });
  };

  return (
    <Select
      data-component-name="LANGUAGE_PICKER"
      className={classes.select}
      value={currentLanguage}
      onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
        const language = event.target.value as string;

        dispatch(setMDLanguage(language));

        i18n.changeLanguage(language);
      }}
    >
      {render()}
    </Select>
  );
};

export default LanguagePicker;
